import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Briefcase, Clock, ArrowLeft } from "lucide-react";
import "./RegistrationStyles.css";

const url = process.env.REACT_APP_BACKEND_URL;

const CustomerJobs = () => {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    fetchJobs();
  }, [customerId]);

  const fetchJobs = async () => {
    try {
      const [jobsRes, customerRes] = await Promise.all([
        axios.get(`${url}/api/jobavailabity/customer/${customerId}`),
        axios.get(`${url}/api/customer/${customerId}`)
      ]);

      setJobs(jobsRes.data.data || []);
      setCustomer(customerRes.data.data);
    } catch (error) {
      alert("Failed to load job availabilities");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading job availabilities...</div>;

  return (
    <div className="jobs-container">
      <button onClick={() => navigate('/registration/customers')} className="back-btn">
        <ArrowLeft size={16} /> Back to Customers
      </button>

      <div className="jobs-header">
        <h2>
          <Briefcase size={24} /> 
          Job Availabilities - {customer?.fullname}
        </h2>
      </div>

      <div className="jobs-grid">
        {jobs.length === 0 ? (
          <p className="no-data">No job availabilities found for this customer</p>
        ) : (
          jobs.map(job => (
            <div key={job._id} className="job-card">
              <div className="job-header">
                <h3>{job.jobname?.category_name}</h3>
                <span className="job-no">#{job.no}</span>
              </div>
              
              <div className="job-section">
                <Clock size={16} />
                <span className={`section-badge ${job.section?.toLowerCase().replace(' ', '-')}`}>
                  {job.section}
                </span>
              </div>

              <div className="job-footer">
                <span className={`status-badge ${job.status}`}>
                  {job.status === "active" ? "Active" : "Inactive"}
                </span>
                <span className="job-date">
                  {new Date(job.createdAt).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CustomerJobs;